<template>
    <main style="text-align: center">
        <h1>Εκτύπωση Ειδικού Φύλλου Πορείας</h1>
        <button class="btn btn-success" v-on:click="exportPDF" v-if="$store.getters.hasEfp">Εκτύπωση Ειδικού Φύλλου Πορείας</button>
        <p v-else>Δεν μπορεί να προβληθεί, προς το παρόν, ηλεκτρονικό έντυπο ΕΦΠ για τον συγκεκριμένο λογαριασμό.<br/>
          Σε περίπτωση που απαιτηθεί, μπορείτε να επικοινωνήσετε με τη Μονάδα Επιστράτευσης (ΜΕ) που ανήκετε.</p>
    </main>
</template>

<script>
    import {HTTP} from "../main.js";
    import {Structs} from "../structs.js"
    require("pdfmake/build/pdfmake.js");
    require("pdfmake/build/vfs_fonts.js");
    var pdfMake = require('pdfmake/build/pdfmake.js');
    var pdfFonts = require('pdfmake/build/vfs_fonts.js');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    export default {
        data: function() {
            return {
                simpleUser: Structs.SimpleUser()
            };
        },

        mounted() {
            var efsa = this.$store.getters.efsa;

            let url = "/users/" + efsa;

            this.$store.dispatch('loading');

            HTTP.get(url).then(response => {
                this.simpleUser = response.data;
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },

        methods: {
            getBase64ImageFromURL(url) {
                return new Promise((resolve, reject) => {
                    var img = new Image();
                    img.setAttribute("crossOrigin", "anonymous");
                    img.onload = () => {
                        var canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        var dataURL = canvas.toDataURL("image/png");
                        resolve(dataURL);
                    };
                    img.onerror = error => {
                        reject(error);
                    };
                    img.src = url;
                });
            },

            exportPDF() {
                this.$store.dispatch("export").then(res => {
                    
                    let binaryString = window.atob(res.data);

                    let binaryLen = binaryString.length;

                    let bytes = new Uint8Array(binaryLen);

                    for (let i = 0; i < binaryLen; i++) {
                        let ascii = binaryString.charCodeAt(i);
                        bytes[i] = ascii;
                    }

                    let blob = new Blob([bytes], {type: "application/pdf"});

                    let link = document.createElement('a');

                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'efp.pdf';

                    link.click();
                })
            },

            async generate() {
                var today = new Date();
                var currentDate = today.getDate() + "/" + (today.getMonth()+1) + "/" + today.getFullYear();

                var mainText = "Ο κάτωθι υπογεγραμμένος " + this.simpleUser.efedros.efEpwnymo + " " + this.simpleUser.efedros.efOnoma + " με ΑΣΜ " + this.simpleUser.efedros.efSa +  " δηλώνω υπεύθυνα ότι ολοκλήρωσα την εγγραφή μου στην Ηλεκτρονική Εφαρμογή Αποστολής Ειδοποίησης Εφέδρου.\n\n\n";
                var signature = currentDate + "\n" + "-Ο-" + "Δηλών";
                var docDefinition = {

                    pageSize: 'A4',
                    pageMargins: [ 80, 100 ],
                    background: [{
                        image: await this.getBase64ImageFromURL("/files/HellenicArmySeal.png"),
                        opacity: 0.3,
                        width: 400,
                        absolutePosition: {x: 100, y: 200}
                    }],

                    header: {
                        margin: 40,
                        alignment: 'center',
                        text: 'ΥΠΕΥΘΥΝΗ ΔΗΛΩΣΗ', 
                        bold: true,
                        decoration: 'underline',
                        fontSize: 22
                    },

                    content: [
                        {text: mainText, style: 'mainText'},
                        {text: signature, style: 'signature'}
                    ],

                    styles: {
                        mainText: {
                            alignment: 'justify',
                            pageBreak: 'before'
                        },
                        signature: {
                            alignment: 'right',
                            italics: true
                        },
                    }
                }

                pdfMake.createPdf(docDefinition).download("vevaiwsiEggrafis.pdf");
            }
        },
    };
</script>
               